import { logger } from '@/utils/logger';
import { AccountTypeSelector } from '@/components/accounts/AccountTypeSelector';
import { OnboardingPage } from '@/components/auth/OnboardingPage';
import appServices from '@/services/appServices';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useState } from 'react';
import { z } from 'zod';

const onboardingSearchSchema = z.object({
  modal: z.enum(['bank-connection']).optional().catch(undefined),
  step: z.number().int().min(1).max(3).optional().catch(1),
});

export const Route = createFileRoute('/onboarding/')({
  component: RouteComponent,
  validateSearch: onboardingSearchSchema,
  beforeLoad: () => {
    logger.debug('/onboarding beforeLoad check');

    // Wait for auth service to initialize
    if (!appServices.auth.isInitialized) {
      logger.debug('Auth service not initialized yet, waiting...');
      return;
    }

    // Rule 1: Must be authenticated to access onboarding
    if (!appServices.auth.isAuthenticated()) {
      logger.debug('Not authenticated, redirecting to /auth');
      throw redirect({ to: '/auth' });
    }

    // Rule 2: If onboarding already completed, go to dashboard
    const userSettings = appServices.auth.getUserSettings();
    if (userSettings?.onboarding_completed === 'true') {
      logger.debug('Onboarding already completed, redirecting to /dashboard');
      throw redirect({ to: '/dashboard' });
    }

    logger.debug(
      'Authenticated and onboarding not completed, showing onboarding'
    );
  },
});

function RouteComponent() {
  const [isModalOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <OnboardingPage isAddingAccount={isModalOpen} onAddAccount={openModal} />
      {isModalOpen && (
        <AccountTypeSelector isOpen={isModalOpen} onClose={closeModal} />
      )}
    </>
  );
}
